export default __webpack_public_path__ + "static/media/logo-us-skechers.04934562.svg";